<template>
    <el-form :model="dioForm" label-width="150px">
        <el-row>
            <el-col v-for="item in appArray" :key="item.code" :span="8">
                <el-form-item :label="getLanguage() === 'zh_CN'?item.name:item.code">
                    <span>{{ item.content }}</span>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import { getLanguage } from '@/lang';

export default {
    props: ['appArray'],
    data() {
        return {
            dioForm: {},
            getLanguage
        }
    },
}
</script>

<style>
</style>